module.exports = __webpack_public_path__ + "static/media/ISO_45001.8ffb6207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ISO_45001.jpg
// module id = 1594
// module chunks = 0